import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import RealtimeExtend from 'ext:flarum/realtime/forum/extenders/Realtime';
export default function extendRealtime() {
  new RealtimeExtend().onUserChannelEvent('flagged', data => {
    var _app$session$user;
    app.session.user = app.store.pushPayload(data);
    app.forum.pushAttributes({
      flagCount: (_app$session$user = app.session.user) == null ? void 0 : _app$session$user.attribute('newFlagCount')
    });
    app.flags.clear();
    m.redraw();
  }).extend(app, {
    name: 'flarum-flags',
    exports: {}
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    var _app$websocket_channe;
    (_app$websocket_channe = app.websocket_channels.user) == null || _app$websocket_channe.bind('flaggedStream', data => {
      var _this$discussion;
      const discussion = app.store.pushPayload(data);
      if ((discussion == null ? void 0 : discussion.id()) === ((_this$discussion = this.discussion) == null ? void 0 : _this$discussion.id()) && this.stream) {
        app.store.find('posts', {
          filter: {
            discussion: discussion.id()
          },
          include: 'flags,flags.user'
        }).then(() => this.stream.update()).then(() => m.redraw());
      }
    });
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    var _app$websocket_channe2;
    (_app$websocket_channe2 = app.websocket_channels.user) == null || _app$websocket_channe2.unbind('flaggedStream');
  });
}